import type BookingsPageSettingsSchema from './schema/BookingsPageStore';
import type BookingTimeSlotInterval from 'owa-service/lib/contract/BookingTimeSlotInterval';
import type PublishingSettings from 'owa-service/lib/contract/PublishingSettings';
import type SelfServicePageAuthType from 'owa-service/lib/contract/SelfServicePageAuthType';
import type TwilioSettings from 'owa-service/lib/contract/TwilioSettings';
import { createStore } from 'owa-satcheljs';

export const publishingSettings: PublishingSettings = {
    IsPublished: true, //changing core paradigm that all pages are by default published.
    PublishedUrl: '',
    FriendlyUrl: '',
    DefaultSchedulingPolicy: {
        LeadTimeInMinutes: 1440, // default is 24hrs
        LeadTimeForBookingsInMinutes: 1440,
        LeadTimeForCancellationsInMinutes: 1440,
        EndOfBookingWindowInDays: 365,
        TimeSlotIntervalInMinutes: 30,
        SendConfirmationsToMailboxOwner: true,
        AllowStaffSelection: true,
        SendMeetingInviteToCustomer: false,
        ServiceBookableWindows: [],
    },
    IsLogoHidden: false,
    IsConsentNeeded: false,
    ConsentText: '',
    AuthType: 1, // will come from tenant admin settings. Default to business.
    IsSearchEngineIndexabilityDisabled: false,
    ShowTimeSlotsInBusinessTimeZone: false,
};

export const twilioSettings: TwilioSettings = {
    AccountSid: '',
    AccountAuthToken: '',
    TwilioNumber: '',
};

const defaultSchemaStore: BookingsPageSettingsSchema = {
    publishingSettings,
    isSocialSharingRestricted: true,
    twilioSettings,
};

const getPageSettingsStore = createStore<BookingsPageSettingsSchema>(
    'BookingsPageSettingsStore',
    defaultSchemaStore
);

export default getPageSettingsStore;
